import React, { useEffect, useRef, useState } from 'react';

const Testimonial = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const carouselRef = useRef(null);
    const intervalRef = useRef(null);

    const testimonials = [
        {
            text: "Saiful Islam Shanto is a skilled professional with a solid understanding of Node.js, React.js, JavaScript, and TypeScript. His ability to write clean and efficient code, combined with his problem-solving skills, makes him an excellent developer. I enthusiastically recommend Saiful for any projects involving these technologies.",
            name: "Rubel Ahmed",
            title: "Software Engineer, NextVenture Ltd.",
        },
        {
            text: "I highly recommend Shanto as a web developer. I have consistently been impressed by his cool and calm demeanor, which makes working with him a pleasure.  I have no doubt that Shanto's skills, work ethic, and passion for web development will continue to make him a valuable asset to any team or organization.",
            name: "Imtiaz Rahi",
            title: "CEO, UhuruTek Solutions",
        },
        {
            text: "I saw good qualities in Shanto, like always he eager to learn new technologies, maintain code quality, helpful minded, problem can solve efficient way and Shanto can actively team work. Best of luck for future.",
            name: "Mahmud Siddeky",
            title: "Software Engineer, ShurjoMukhi Limited",
        },
    ];

    const updateCarousel = () => {
        if (carouselRef.current) {
            const width = carouselRef.current.clientWidth;
            carouselRef.current.style.transform = `translateX(-${currentIndex * width}px)`;
        }
    };

    const nextTestimonial = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    };

    const prevTestimonial = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length);
    };

    useEffect(() => {
        updateCarousel();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentIndex]);

    useEffect(() => {
        const handleResize = () => updateCarousel();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const startAutoPlay = () => {
            intervalRef.current = setInterval(() => {
                nextTestimonial();
            }, 5000); // Change slide every 7 seconds
        };

        const stopAutoPlay = () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };

        startAutoPlay(); // Start autoplay

        return () => stopAutoPlay(); // Clear interval on component unmount
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleMouseEnter = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current); // Stop autoplay on hover
        }
    };

    const handleMouseLeave = () => {
        intervalRef.current = setInterval(() => {
            nextTestimonial(); // Restart autoplay when mouse leaves
        }, 5000);
    };

    return (
        <>
            <br />
            <h2> <span className='text-blue-500'>T</span>estimonial</h2>
            <hr />
            <div className="mx-auto mt-4">
                <div
                    className="relative overflow-hidden px-6"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    <div ref={carouselRef} className="flex transition-transform duration-700 ease-in-out">
                        {testimonials.map((testimonial, index) => (
                            <div
                                key={index}
                                className="min-w-full p-6 border border-gray-200 rounded-lg shadow-lg text-center"
                            >
                                <p className="text-lg italic text-dark-200">
                                    "{testimonial.text}"
                                </p>
                                <h5 className="mt-4 text-xl font-semibold text-gray-600 ">
                                    {testimonial.name}
                                </h5>
                                <p className="text-gray-500 ">{testimonial.title}</p>
                            </div>
                        ))}
                    </div>

                    {/* Previous Button */}
                    <button
                        onClick={prevTestimonial}
                        className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-gray-200 text-gray-700 p-2 rounded-full shadow-md hover:bg-gray-300 focus:outline-none"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                        </svg>
                    </button>

                    {/* Next Button */}
                    <button
                        onClick={nextTestimonial}
                        className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-gray-200 text-gray-700 p-2 rounded-full shadow-md hover:bg-gray-300 focus:outline-none"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                        </svg>
                    </button>
                </div>
            </div>
        </>
    );
};

export default Testimonial;
